import React from 'react'
import MembershipResponsiveTable from '../../components/form/MembershipResponsiveTable'
const Membership = () => {
  return (
   <MembershipResponsiveTable/>
  )
}

export default Membership